import { render, staticRenderFns } from "./customerIcon.vue?vue&type=template&id=65e6151a"
import script from "./customerIcon.vue?vue&type=script&lang=js"
export * from "./customerIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports